import React from 'react'
import { Row, Col } from "react-bootstrap";
import { PageLinks } from '../../../common/site/page-static-links'
import { Link } from 'gatsby'

const ResidentialDetailSearch = ({ popularSearchDetailsObject }) => {

    let { searchType, area } = popularSearchDetailsObject
    const defaultAreas = [
        { slug: "cornwall", label: "Cornwall" },
        { slug: "devon", label: "Devon" },
        { slug: "somerset", label: "Somerset" },
        { slug: "dorset", label: "Dorset" },
    ]
    // string capitalize
    function capitalize(value) {
        let capStr = value.charAt(0).toUpperCase() + value.slice(1)
        capStr = capStr.replace("-", " ")
        return capStr
    }

    let actionText = "";
    let url = "";
    let typeText = "property"
    let areaUrl = ""
    let areaText = ""
    let lastcolumnareaText = ""

    if (searchType === "sales") {
        actionText = "for sale"
        url = "properties/for-sale"
    } else {
        actionText = "to rent"
        url = "properties/to-rent"
    }

    if (area) {
        areaUrl = area.toLowerCase().replaceAll(" ", "-")
        areaText = `in ${area}`
        lastcolumnareaText = area
        areaUrl = `in-${areaUrl}`
    }

    // if (postcode) {
    //     postcode = postcode.split(" ")[0]
    //     areaUrl = `in-${postcode.replace(" ", "-").toLowerCase()}`
    //     areaText = `in ${postcode.toUpperCase()}`
    //     lastcolumnareaText = postcode.toUpperCase()
    // }

    return (
        <div className={`row`}>
            <Col xl={3}>
                <ul className='list-unstyled popular-searches-list'> 
                    {defaultAreas.map((area, k) => {
                        return (
                            <li key={k}><a href={`/${url}/in-${area.slug}/radius-3/`}>{capitalize(typeText)} {actionText} in {area.label}</a></li>
                        )
                    })}
                </ul>
            </Col>
            <Col xl={3}>
                <ul className='list-unstyled popular-searches-list'>
                    <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}1-bedroom/`}>1 bedroom property {actionText} {areaText}</a></li>
                    <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}2-bedrooms/`}>2 bedrooms property {actionText} {areaText}</a></li>
                    <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}3-bedrooms/`}>3 bedrooms property {actionText} {areaText}</a></li>
                    <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}4-bedrooms/`}>4 bedrooms property {actionText} {areaText}</a></li>
                </ul>
            </Col>
            <Col xl={3}>
                <ul className='list-unstyled popular-searches-list'>
                    <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}`}>Property {actionText} {areaText}</a></li>
                    <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}type-house/`}>Houses {actionText} {areaText}</a></li>
                    <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}type-apartments/`}>Apartments {actionText} {areaText}</a></li>
                    <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}type-bungalow/`}>Bungalows {actionText} {areaText}</a></li>
                </ul>
            </Col>
            <Col xl={3}>
                <ul className='list-unstyled popular-searches-list'> 
                    <li><a href={`/${PageLinks.about}/`}>About us</a></li>
                    <li><a href={`/${PageLinks.team}/`}>Meet the team</a></li>
                    <li><a href={`/${PageLinks.news}/`}>Latest property news</a></li>
                    <li><a href={`/${PageLinks.career}/`}>Careers</a></li>
                </ul>
            </Col>
        </div>
    )
}

export default ResidentialDetailSearch